import { render, staticRenderFns } from "./basic-layout.vue?vue&type=template&id=7f669408&"
import script from "./basic-layout.vue?vue&type=script&lang=js&"
export * from "./basic-layout.vue?vue&type=script&lang=js&"
import style0 from "./basic-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports